import "../libs/backbone/backbone.ajaxq.adapter.ts";
import "../libs/bootstrap/js/bootstrap.min.js";
import "../libs/notify/notify.min.js";
import '../libs/timepicker/js/timepicker.min.js';
import "global_functions.js";
import "../libs/chosen/js/chosen.jquery.min.js";
import i18n from 'l10n';
import 'dhtmlxMessage';

window.ping = function() {
    return $.ajaxDefaultQ({
        url: 'rest/ping',
        type: 'GET',
        dataType: "json",
        success: function(response, status, xhr) {
            if(!xhr || response.status != "success")
                return;

            window.csrf = xhr.getResponseHeader('X-CSRF-TOKEN');

            $.ajaxPrefilter(function( options, originalOptions, jqXHR ) {
                var nonEligibleRequests = "get|head|options|trace";
                var eligibleRequests = "post|delete|put|patch";

                if(originalOptions.type && nonEligibleRequests.indexOf(originalOptions.type.toLowerCase()) == -1) {
                    var csrf = window.csrf;
                    jqXHR.setRequestHeader('X-CSRF-TOKEN', csrf);

                }

            });

        },
        fail: function(error) {
            var errorMsg = "";
            var statusCode = error.status;
            var systemErrorCode = error.responseJSON && error.responseJSON.error && error.responseJSON.error.exception && error.responseJSON.error.exception.code ? error.responseJSON.error.exception.code : -1;

            if(statusCode == 502)
                 errorMsg = i18n.t("server.is_down");
            else
                errorMsg = i18n.t("server.error");

            dhtmlx.alert({
                type: "alert",
                text: errorMsg,
                callback: function (result) {

                }
            });
        }
    });

}

import TheRouter from "routers/dashboard.router.ts";
var token = window.csrf;
var loggedIn = false;
var data = null;

$.ajaxDefaultQ({
	url: 'rest/api/user?extra=org',
	type: 'GET',
}).done(function(response, status, xhr){
	if(status == "success")
	{
		loggedIn = true;

		data = response.data;
	}
})
.fail(function(response) {

})
.always(function(){
	var router = new TheRouter({token: token, loggedIn: loggedIn, data: data});
	Backbone.history.start();
});